/* eslint no-unused-vars: "off" */
/* eslint func-names: "off" */
/* eslint no-console: "off" */
/* eslint no-unused-expressions: "off" */
/* eslint sonarjs/cognitive-complexity: "off" */
/* eslint no-param-reassign: "off" */
/* eslint sonarjs/no-duplicate-string: "off" */
/* eslint eqeqeq: "off" */
/* eslint no-shadow: "off" */
/* eslint no-plusplus: "off" */
/* eslint vars-on-top: "off" */
/* eslint no-var: "off" */
/* eslint no-redeclare: "off" */
/* eslint no-use-before-define: "off" */
/* eslint sonarjs/no-redundant-boolean: "off" */
/* eslint sonarjs/no-identical-functions: "off" */
/* eslint max-len: "off" */
/* eslint no-alert: "off" */

/* ========================================================================
 * OctoberCMS: front-end JavaScript extras
 * http://octobercms.com
 * ========================================================================
 * Copyright 2016-2020 Alexey Bobkov, Samuel Georges
 * ======================================================================== */

+(function ($) {
  if ($.oc === undefined) $.oc = {};

  // @todo Provide an interface for configuration
  // - Custom loader CSS class
  // - Custom stripe loader color
  // - Flash message interval

  const LOADER_CLASS = 'oc-loading';

  // FLASH HANDLING
  // ============================

  $(document).on('ajaxSetup', '[data-request][data-request-flash]', (event, context) => {
    context.options.handleErrorMessage = function (message) {
      $.oc.flashMsg({ text: message, class: 'error' });
    };

    context.options.handleFlashMessage = function (message, type) {
      $.oc.flashMsg({ text: message, class: type });
    };
  });

  // FORM VALIDATION
  // ============================

  $(document).on('ajaxValidation', '[data-request][data-request-validate]', function (event, context, errorMsg, fields) {
    const $this = $(this).closest('form');
    let $container = $('[data-validate-error]', $this);
    let messages = [];
    let $field;

    $.each(fields, (fieldName, fieldMessages) => {
      $field = $(`[data-validate-for="${fieldName}"]`, $this);
      messages = $.merge(messages, fieldMessages);
      if ($field.length) {
        if (!$field.text().length || $field.data('emptyMode') == true) {
          $field
            .data('emptyMode', true)
            .text(fieldMessages.join(', '));
        }
        $field.addClass('visible');
      }
    });

    if ($container.length) {
      $container = $('[data-validate-error]', $this);
    }

    if ($container.length) {
      const $oldMessages = $('[data-message]', $container);
      $container.addClass('visible');

      if ($oldMessages.length) {
        const $clone = $oldMessages.first();

        $.each(messages, (key, message) => {
          $clone.clone().text(message).insertAfter($clone);
        });

        $oldMessages.remove();
      } else {
        $container.text(errorMsg);
      }
    }

    $this.one('ajaxError', (event) => {
      event.preventDefault();
    });
  });

  $(document).on('ajaxPromise', '[data-request][data-request-validate]', function () {
    const $this = $(this).closest('form');
    $('[data-validate-for]', $this).removeClass('visible');
    $('[data-validate-error]', $this).removeClass('visible');
  });

  // LOADING BUTTONS
  // ============================

  $(document)
    .on('ajaxPromise', '[data-request]', function () {
      const $target = $(this);

      if ($target.data('attach-loading') !== undefined) {
        $target
          .addClass(LOADER_CLASS)
          .prop('disabled', true);
      }

      if ($target.is('form')) {
        $('[data-attach-loading]', $target)
          .addClass(LOADER_CLASS)
          .prop('disabled', true);
      }
    })
    .on('ajaxFail ajaxDone', '[data-request]', function () {
      const $target = $(this);

      if ($target.data('attach-loading') !== undefined) {
        $target
          .removeClass(LOADER_CLASS)
          .prop('disabled', false);
      }

      if ($target.is('form')) {
        $('[data-attach-loading]', $target)
          .removeClass(LOADER_CLASS)
          .prop('disabled', false);
      }
    });

  // STRIPE LOAD INDICATOR
  // ============================

  const StripeLoadIndicator = function () {
    const self = this;
    this.counter = 0;
    this.indicator = $('<div/>').addClass('stripe-loading-indicator loaded')
      .append($('<div />').addClass('stripe'))
      .append($('<div />').addClass('stripe-loaded'));
    this.stripe = this.indicator.find('.stripe');

    $(document).ready(() => {
      $(document.body).append(self.indicator);
    });
  };

  StripeLoadIndicator.prototype.show = function () {
    this.counter++;

    // Restart the animation
    this.stripe.after(this.stripe = this.stripe.clone()).remove();

    if (this.counter > 1) {
      return;
    }

    this.indicator.removeClass('loaded');
    $(document.body).addClass('oc-loading');
  };

  StripeLoadIndicator.prototype.hide = function (force) {
    this.counter--;

    if (force !== undefined && force) {
      this.counter = 0;
    }

    if (this.counter <= 0) {
      this.indicator.addClass('loaded');
      $(document.body).removeClass('oc-loading');
    }
  };

  $.oc.stripeLoadIndicator = new StripeLoadIndicator();

  // STRIPE LOAD INDICATOR DATA-API
  // ============================

  $(document)
    .on('ajaxPromise', '[data-request]', function (event) {
      // Prevent this event from bubbling up to a non-related data-request
      // element, for example a <form> tag wrapping a <button> tag
      event.stopPropagation();

      $.oc.stripeLoadIndicator.show();

      // This code will cover instances where the element has been removed
      // from the DOM, making the resolution event below an orphan.
      const $el = $(this);
      $(window).one('ajaxUpdateComplete', () => {
        if ($el.closest('html').length === 0) $.oc.stripeLoadIndicator.hide();
      });
    })
    .on('ajaxFail ajaxDone', '[data-request]', (event) => {
      event.stopPropagation();
      $.oc.stripeLoadIndicator.hide();
    });

  //   // FLASH MESSAGE
  //   // ============================

  //   var FlashMessage = function (options, el) {
  //     var
  //       options = $.extend({}, FlashMessage.DEFAULTS, options);
  //     let $element = $(el);

  //     $('body > p.flash-message').remove();

  //     if ($element.length == 0) {
  //       $element = $('<p />').addClass(options.class).html(options.text);
  //     }

  //     $element
  //       .addClass('flash-message fade')
  //       .attr('data-control', null)
  //       .on('click', 'button', remove)
  //       .on('click', remove)
  //       .append('<button type="button" class="close" aria-hidden="true">&times;</button>');

  //     $(document.body).append($element);

  //     setTimeout(() => {
  //       $element.addClass('in');
  //     }, 100);

  //     const timer = window.setTimeout(remove, options.interval * 1000);

  //     function removeElement() {
  //       $element.remove();
  //     }

  //     function remove() {
  //       window.clearInterval(timer);

  //       $element.removeClass('in');
  //       $.support.transition && $element.hasClass('fade')
  //         ? $element
  //           .one($.support.transition.end, removeElement)
  //           .emulateTransitionEnd(500)
  //         : removeElement();
  //     }
  //   };

  //   FlashMessage.DEFAULTS = {
  //     class: 'success',
  //     text: 'Default text',
  //     interval: 5,
  //   };

  //   if ($.oc === undefined) $.oc = {};

  //   $.oc.flashMsg = FlashMessage;

  //   // FLASH MESSAGE DATA-API
  //   // ===============

  //   $(document).render(() => {
  //     $('[data-control=flash-message]').each(function () {
  //       $.oc.flashMsg($(this).data(), this);
  //     });
  //   });
  //   $(window).on('ajaxErrorMessage', (event, message) => {
  //     // This can be any custom JavaScript you want
  //     alert(`Something bad happened, mate, here it is: ${message}`);

//     // This will stop the default alert() message
//     event.preventDefault();
//   });
}(window.jQuery));


export default new class Register {
  constructor() {
    this.registerFormSelector = 'register__form';
    this.registerEmailSelector = 'register__email';
    this.registerPasswordSelector = 'register__password';
    this.submitBtnSelector = 'register__submit';
    this.inValidSelector = '_invalid';
    this.successSelector = 'register__success';
    this.successVisibleSelector = 'register__success_visible';
    this.preLoaderSelector = 'register__preloader';
    this.delay = 2000;

    this.handler();
  }

  handler() {
    const form = document.querySelector(`.${this.registerFormSelector}`);

    if (!form) return;

    const submitBtn = form.querySelector(`.${this.submitBtnSelector}`);

    submitBtn.addEventListener('click', () => {
      $('.validation-error__message').remove();
      setTimeout(() => {
        this.checkForm(form);
      }, 0);
    });
  }

  checkForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const input = form.querySelector(`.${this.registerEmailSelector}`);
    const email = form.querySelector(`.${this.registerEmailSelector}`).value;
    const password = form.querySelector(`.${this.registerPasswordSelector}`).value;

    $.request('onSignin', {
      data: {
        email,
        password,
      },

      loading: `.${this.preLoaderSelector}`,
      complete: (res) => {
        this.showTooltip(res);
        setTimeout(() => {
          input.dispatchEvent(new Event('change', {
            bubbles: true,
          }));
        }, this.delay);
      },
      error: (res) => {
        window.alert = function () {};
        window.alert = function () {};
        if (res.status === 500) $('#password__input').after(`<div class="validation-error__message">${res.responseText}</div>`);
        else {
          $.each(res.responseJSON.X_OCTOBER_ERROR_FIELDS, (index, value) => {
            $(`#${index}__input`).after(`<div class="validation-error__message">${value[0]}</div>`);
          });
        }
      },
    });
  }

  showTooltip(res) {
    const { statusText } = res;

    if (statusText !== 'OK') return;

    const successNode = this.getToolTip();

    successNode.classList.add(this.successVisibleSelector);

    setTimeout(() => {
      this.hideToolTip();
    }, this.delay);
  }

  hideToolTip() {
    const successNode = this.getToolTip();

    successNode.classList.remove(this.successVisibleSelector);
  }

  getToolTip() {
    return document.querySelector(`.${this.successSelector}`);
  }
}();
